<template>
  <div class="app-header">
    <popopmenue
      v-if="showMenu"
      :want-to-make-offer="showMenu"
      @oga="retourPopup"
    />
    <div class="web-header w-full">
      <div class="pt-3 pb-3 w-full h-full header-container flex">
        <div
          class="flex-one w-1/3 flex items-center logo-section h-full"
          @click="accueil()"
        >
          <svg-icon
            name="logo"
            class="h-8 cursor-pointer"
            original
          />
        </div>

        <div class="w-full h-full items-center flex justify-end mr-4">
          <svg-icon
            name="ic_menu"
            class="h-10 cursor-pointer"
            original
            @click="openPopup()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popopmenue from '@/components/popup/popupMenue'
export default {
  name: 'TheHeader',
  components: {
    popopmenue
  },
  data () {
    return {
      showMenu: false
    }
  },
  methods: {
    accueil () {
      this.$router.push('/accueil')
    },
    openPopup () {
      this.showMenu = !this.showMenu
    },
    retourPopup (answer) {
      this.showMenu = answer
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style/sass/variables";

.app-header {
  background: white;
  z-index: 999;
  height: auto;
  position: relative;
}
.header-container{
  padding-right: $padding-r;
  padding-left: $padding-l;
  height: 5.5rem;
}
.svg-fill{
  fill: white;
}
@media only screen and (max-width: 600px) {
  .header-container{
    padding-right: 10px;
    padding-left:  30px;
  }
}
</style>
